var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCw2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e8cde3;\n        stroke: #9e1f63;\n        stroke-miterlimit: 10;\n        stroke-width: 4px;\n      }\n\n      .cls-2 {\n        fill: #9e1f63;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 22,
    cy: 22,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.36,29.83h8.16c.81,0,1.43,.17,1.86,.5,.43,.33,.64,.79,.64,1.36,0,.51-.17,.94-.51,1.3-.34,.35-.85,.53-1.54,.53h-11.5c-.78,0-1.39-.22-1.83-.65-.44-.43-.66-.94-.66-1.52,0-.38,.14-.87,.42-1.49,.28-.62,.59-1.11,.92-1.46,1.39-1.44,2.64-2.67,3.75-3.7,1.11-1.03,1.91-1.7,2.39-2.02,.85-.6,1.56-1.21,2.13-1.82,.57-.61,1-1.23,1.3-1.88s.45-1.27,.45-1.88c0-.67-.16-1.26-.48-1.79-.32-.53-.75-.93-1.3-1.23-.55-.29-1.14-.44-1.79-.44-1.36,0-2.44,.6-3.22,1.8-.1,.16-.28,.58-.52,1.28-.25,.7-.52,1.23-.83,1.61-.31,.38-.76,.56-1.35,.56-.52,0-.95-.17-1.3-.52s-.52-.81-.52-1.41c0-.72,.16-1.47,.48-2.25,.32-.78,.8-1.49,1.45-2.12,.64-.63,1.45-1.15,2.44-1.54s2.14-.59,3.46-.59c1.59,0,2.95,.25,4.08,.75,.73,.33,1.37,.79,1.92,1.38,.55,.58,.98,1.26,1.29,2.02,.31,.77,.46,1.56,.46,2.38,0,1.29-.32,2.47-.96,3.52-.64,1.06-1.29,1.89-1.96,2.48-.67,.6-1.78,1.54-3.35,2.82-1.57,1.28-2.64,2.28-3.23,2.98-.25,.28-.51,.62-.77,1.02Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCw2);
export default __webpack_public_path__ + "static/media/CW2.e3ac70d8ce51ff1cc02f86f2512520ef.svg";
export { ForwardRef as ReactComponent };